<template>
  
   <div class ="AEMbodypart"> 
      <form class="AEM_body" >
        <div class="Aemtitle">
            <h2>{{ $t('checkout.personalDetails.common.popUp.sub', 'Please fill the Subscription information you want to terminate.') }}</h2>
           <br>
           <p>{{ $t('checkout.personalDetails.common.createAccount.msg', 'you can find required subscription information on your invoice') }}</p>
          </div>
        <div class="content1">
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            :placeholder="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            v-model.trim="name"
            
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            :placeholder="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            v-model.trim="surName"
           
          />
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            :placeholder="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            v-model.trim="fromEmail"
            
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            :placeholder="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            v-model.trim="subscriptionNumber"
          />
        </div>
        <div class = "terminate">
         <app-button
               type="submit"
               :disabled="(!name || !surName || !fromEmail || !subscriptionNumber)"
               @click.prevent="openModalStep3"
                >
                  {{ $t('checkout.personalDetails.cancellation.popUp.button.terminate', "Terminate contract") }}
         </app-button>
        </div>
        </form>
       
         <app-modal name="CancelReplenishment1"  :clickToClose="false" width="500px">
            <div class="cancelemail">
              <h2>
                {{ $t('checkout.personalDetails.common.mailsub', "We have received your request to terminate the contract.") }}
              </h2>
                <p >{{ $t('checkout.personalDetails.common.createAccount.login.tips7', 'You will receive a confirmation to your mail') }}</p>
          </div>   
          <div class ="close">
           <app-button
            @click.prevent="test"
                >
            {{ $t('checkout.personalDetails.cancellation.popUp.closebutton', "Close") }}
        </app-button>
         </div>
        </app-modal>
       </div>
  
</template>


<script>
  
  import Vue from 'vue'
  
  
  

  export default {
    name: 'subscription-contractcancel',

   

    components: {
    },

    data () {
      return {
        name: null,
        surName: null,
        fromEmail:null,
        subscriptionNumber:null,
      }
    },

    methods: {


       openModalStep3 () {
        Vue.api.subscription.sendcancelemail(this.name,this.surName,this.fromEmail,this.subscriptionNumber)
        this.$bus.$emit('open-modal', 'CancelReplenishment1')
        

       },

      test () {
      this.$bus.$emit('close-modal', 'CancelReplenishment1')
       window.location.reload()
       },

    }
  }
</script>

<style lang="scss">
  .AEM_body {
    width: 50%;
    padding: 60px;
    border: 1px solid #ccc;
    margin: 50px auto;
    background-color: #e8e8e8;
  }

  .terminate {
    text-align: center;
  }

  .Aemtitle {
    text-align: center;
  }

  .cancelemail {
    text-align: center;
  }

  .close {
    text-align: center;
  }

  .AEMbodypart {
    .v--modal-box {
      .closeButton {
        display: none;
      }
    }
  }
</style>





